import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withWidth, Grid, Paper } from '@material-ui/core'
import { Typography, SwxTheme } from 'swx-atomic-component-lib'

import { connect } from 'react-redux'
import colors from '../helpers/color.helper'
import { Link } from 'react-router-dom'
import i18n from '../i18n'

const styles = theme => ({
  container: {
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: SwxTheme.palette.white,
    height: '100vh',
    background: `${SwxTheme.palette['secondary-dark']} url(/shapes-lines-large.svg)`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'calc(50% - 257px) calc(50% - 214px)',
    [theme.breakpoints.down('sm')]: {
      backgroundSize: '1104.75px 1089.75px'
    },
    [theme.breakpoints.up('sm')]: {
    },
    [theme.breakpoints.down('xs')]: {
      backgroundSize: '736.5px 726.5px',
      backgroundPosition: 'top right'
    }
  },
  form: {
    flex: 1,
    [theme.breakpoints.down('xs')]: {
      paddingTop: '14vh'
    }
  },
  logo: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('lg')]: {
      // top: 240,
      // left: 241,
      top: '20vh',
      left: '11vw'
    },
    [theme.breakpoints.down('lg')]: {
      // top: 200,
      // left: 201,
      top: '19.53125vh',
      left: '14.71449487554905vw'
    },
    [theme.breakpoints.down('md')]: {
      // top: 100,
      // left: 100.8,
      top: '13.15789473684211vh',
      left: '9.84375vw'
    },
    [theme.breakpoints.down('sm')]: {
      // top: 50,
      // left: 75.8,
      top: '8.333333333333333vh',
      left: '9.475vw'
    },
    [theme.breakpoints.down('xs')]: {
      position: 'inherit'
    }
  },
  image: {
    height: 52,
    width: 47
  },
  paper: theme.mixins.gutters({
    width: 480,
    background: 'none',
    boxShadow: 'none',
    [theme.breakpoints.down('xs')]: {
      width: 295
    }
  }),
  welcome: {
    color: colors.blue
  },
  adjective: {
    paddingLeft: 30
  },
  forbidden: {
    fontSize: 20
  },
  bold: {
    fontWeight: 500
  },
  more: {
    color: colors.blue
  },
  link: {
    textDecoration: 'none',
    color: colors.blue
  },
  return: {
    width: 104,
    height: 28,
    borderRadius: 14,
    backgroundColor: SwxTheme.palette.white,
    display: 'flex',
    color: colors.black,
    fontSize: 13,
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    marginTop: 50,
    marginBottom: 32
  },
  italic: {
    fontStyle: 'italic',
    paddingBottom: 16
  },
  pb16: {
    paddingBottom: 16
  }
})

class ErrorPage extends Component {
  state = {
  }

  constructor (props) {
    super(props)
    this.classes = props.classes
  }

  render () {
    const { classes, location } = this.props
    return (
      <div id='error' className={classes.container}>
        <Grid
          container
          spacing={0}
          className={classes.form}
          alignItems='center'
          direction='column'
          justify='center'
        >
          <Grid item container justify='center' className={classes.forbidden}>
            <div className={classes.logo}><img src='symbol-white.svg' alt='SmarterWX Logo' className={classes.image} /><Typography size='32px' color='white'>&nbsp;&nbsp;Oops!</Typography></div>
          </Grid>
          <Grid item xs={11} sm={6} md={6} lg={4} xl={4}>
            <Paper elevation={4} className={classes.paper}>
              <Grid container alignItems='center' className={classes.pb16}>
                <Typography size='20px' color='primary'>{i18n.errorPage.statusTitle}</Typography><Typography size='20px' color='white'>&nbsp;(403)</Typography>
              </Grid>

              <Typography color='white' className={classes.italic}>{i18n.errorPage.statusSubTitle}</Typography>

              <Typography color='white' className={classes.italic}>{i18n.errorPage.adjectiveTitle}</Typography>

              <Grid container spacing={0} direction='column' className={classes.adjective}>
                <Grid container direction='row' className={classes.pb16}>
                  <Grid item xs><Typography color='white'>1.</Typography></Grid>
                  <Grid item xs={11}><Typography color='white' className={classes.bold}>{i18n.errorPage.adjectiveDesc1}</Typography></Grid>
                </Grid>
                <Grid container direction='row'>
                  <Grid item xs><Typography color='white'>2.</Typography></Grid>
                  <Grid item xs={11}><Typography color='white' ellipsis={false}>{i18n.errorPage.adjectiveDesc2}</Typography></Grid>
                </Grid>
              </Grid>
              <Link
                to={{ pathname: '/login', search: location.search }} className={classes.return}
              >{i18n.common.button.return}
              </Link>
              <Typography>
                <Link to={{ pathname: '/login', search: location.search }} className={classes.link}>
                  {i18n.errorPage.link}
                </Link>
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}

const ErrorComponent = withStyles(styles)(withWidth()(ErrorPage))

function mapStateToProps (state) {
  return {
    self: state.self
  }
}

export default connect(mapStateToProps, { /* methods */ })(ErrorComponent)
